<mat-icon class="float-right rounded pt-2 pb-2 pl-3 pr-3 botonesCerrar" (click)="cerrarTodo()" style="cursor: pointer;"> cancel_presentation</mat-icon>
<section class="container-fluid" style="background-color: white;">
    <div class="row">
        <div class="col-12">
            <img src="{{data.mapaImagen.url}}" style="width: 100%;">
        </div>
    </div>
</section>